export default {
  'customer_id': 1,
  'first_name': 'Anca',
  'last_name': 'Breje',
  'nickname': 'asperiores',
  'email': 'otho.smitham@example.com',
  'phone': '+40 777 333 444',
  'active': true,
  'gender': 'Female',
  'birth_day': '1993-06-01',
  'formatted_address': 'Zorelelor 12, Oradea, Bihor, RO',
  'push_notifications': true,
  'address': [
    {
      'address_id': 55,
      'type': 'billing',
      'street': 'Zorelelor 12',
      'city': 'Oradea',
      'state': 'Bihor',
      'country': 'RO'
    },
    {
      'address_id': 56,
      'type': 'shipping',
      'street': 'Zorelelor 12',
      'city': 'Oradea',
      'state': 'Bihor',
      'country': 'RO'
    }
  ]
}



// WEBPACK FOOTER //
// ./src/components/Dashboard/Views/Customers/customer.js